<mat-grid-list [cols]="2" rowHeight="2:1.4">
    <div *ngFor="let chart of charts">
        <mat-grid-tile>
            <app-chart-details [chart]='chart'></app-chart-details>
        </mat-grid-tile>
    </div>
</mat-grid-list>